import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveLi2Failure, saveLi2Success, updateLi2Failure, updateLi2Success } from './actions';

export function* saveLi2({ payload }) {
  try {
    yield call(api.post, 'api/li2', payload.data, { withCredentials: true });

    yield put(saveLi2Success());

    toast.success('LI2 criado com sucesso!')

    history.push('/specifications/pilar3/resources/li2');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveLi2Failure());
  }
}

export function* updateLi2({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/li2/${id}`, payload.data, { withCredentials: true });

    yield put(updateLi2Success());

    toast.success('LI2 atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/li2');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateLi2Failure());
  }
}

export default all([
  takeLatest('@li2/SAVE_REQUEST', saveLi2),
  takeLatest('@li2/UPDATE_REQUEST', updateLi2)
]);